export enum WorkspaceActionId {
  OPEN_IN_NEW_TAB = "open-in-new-tab",
  SET_DEFAULT = "set-default",
  CHANGE_NAME = "change-name",
  ADD_MEMBER = "add-member",
  FALLBACK_OWNER = "fallback-owner",
}
